module.exports = __webpack_public_path__ + "static/media/church.1aeb17c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/church.svg
// module id = 645
// module chunks = 36